module.exports = __webpack_public_path__ + "static/assets/da39e9ae33fbeed97955277953c2557b.png";